<template>
    <div id="collapsible-panel">
        <div id="panel-header" @click="collapse()">
            <div class="panel-title">
                <div class="panel-info" v-if="panel.info" :title="panel.info" :alt="panel.info">
                    <i class="info-icon fas fa-info-circle"></i> -
                </div>
                {{ title }}
            </div>
            <div v-show="collapsed" class="up-arrow"><i class="fa fa-chevron-up"></i></div>
            <div v-show="!collapsed" class="down-arrow"><i class="fa fa-chevron-down"></i></div>
        </div>
        <div id="panel-content" v-if="!collapsed">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: "CollapsiblePanelComponent",
    props: ['panel', 'folded'],
    created() {
        this.collapsed = this.folded;
        if (this.panel.fullscreen === null || this.panel.fullscreen === undefined) {
            this.panel.fullscreen = false;
        }
    },
    data() {
        return {
            collapsed: false
        }
    },
    computed: {
        title() {
            let title = this.panel.title;
            if (this.panel.subtitle) {
                title += ' - ' + this.panel.subtitle;
            }
            return title;
        }
    },
    methods: {
        collapse: function () {
            if (!this.panel.fullscreen) {
                this.collapsed = !this.collapsed;
                this.$emit("collapsed", this.collapsed);
                this.$emit("update:collapsed", this.collapsed);
            }
        }
    }
}
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#collapsible-panel {
    margin: 14px 10px;
    padding: 6px;
    border: 2px solid #e9effa;
    border-radius: 10px;
    background: linear-gradient(135deg, #f6f8fc 0%, #edf2fa35 100%);
    box-shadow: 6px 6px 5px #edf2fa0f;
    transition: box-shadow 0.16s ease, border-color 0.16s ease;

    &:hover {
        border-color: rgba(33, 33, 70, 0.25);
        box-shadow: 0 10px 26px rgba(19, 24, 41, 0.12);
    }

    #panel-header {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 24px;
        align-items: center;
        padding: 10px 12px;
        border-radius: 8px;
        cursor: pointer;
        user-select: none;

        .panel-title {
            color: #212146;
            font-weight: 600;
            font-size: 0.94rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .up-arrow,
        .down-arrow {
            color: #4e5878;
            font-size: 0.92rem;
            text-align: center;
        }

        .panel-info {
            display: inline;
            cursor: help;

            .info-icon {
                color: @vermelho;
                font-size: 1rem;
            }
        }
    }

    #panel-content {
        padding: 8px 6px 4px;
    }

}
</style>
